var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "verified_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#verified_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.95 13.065-1.623-1.607a.72.72 0 0 0-.514-.213.72.72 0 0 0-.54.228.72.72 0 0 0-.217.527q0 .31.217.527l2.044 2.044q.271.27.633.271.361 0 .633-.27l4.144-4.145a.7.7 0 0 0 .22-.522.77.77 0 0 0-.22-.532.76.76 0 0 0-.535-.24.7.7 0 0 0-.534.225zm-2.54 8.118-1.383-2.325-2.615-.562a.83.83 0 0 1-.538-.354.88.88 0 0 1-.16-.625l.255-2.69-1.779-2.035A.84.84 0 0 1 1.96 12q0-.346.23-.592l1.78-2.035-.256-2.69a.88.88 0 0 1 .16-.625.83.83 0 0 1 .538-.354l2.615-.562L8.41 2.817a.92.92 0 0 1 .492-.404.84.84 0 0 1 .633.033L12 3.49l2.465-1.043a.84.84 0 0 1 .633-.033.92.92 0 0 1 .492.404l1.383 2.325 2.616.562a.83.83 0 0 1 .537.354q.201.288.16.625l-.255 2.69 1.779 2.035q.23.246.23.592t-.23.592l-1.78 2.035.256 2.69a.88.88 0 0 1-.16.625.83.83 0 0 1-.538.354l-2.615.562-1.383 2.325a.92.92 0 0 1-.492.404.84.84 0 0 1-.633-.033L12 20.512l-2.465 1.042a.84.84 0 0 1-.633.033.92.92 0 0 1-.492-.404"
  }))));
};
export default SvgVerified;